// Hook do pobierania listy modułów DevStudio

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';

export interface IModule {
  id: number;
  uuid: string;
  name: string;
}

interface IApiResponse {
  total_count: number;
  total_pages: number;
  items: IModule[];
}

const getModules = async (): Promise<IModule[]> => {
  const response: IApiResponse = await axios.get<IApiResponse>('/panel/dev-studio/modules', {
    params: { limit: 100 }
  }) as unknown as IApiResponse;

  return response?.items ?? [];
};

export const useGetModules = (options?: UseQueryOptions<IModule[], IError>) =>
  useQuery<IModule[], IError>(['modules'], getModules, options);
